import styled from "styled-components";

export const QuizImage = styled.img`
  width: -webkit-fill-available;
  margin: 20px;
`